module.exports = require('./colorbrewer.js');



//////////////////
// WEBPACK FOOTER
// ./~/colorbrewer/index.js
// module id = 948
// module chunks = 6